// --- React
import React from "react";
// --- Styles
import "./styles.scss";

/**
 * SectionHeader Component
 *
 * A header component for form sections with optional action button and item count.
 * Used in forms and drawers to separate content into logical sections.
 *
 * @component
 * @param {Object} props - Component properties
 * @param {string} props.title - The section title
 * @param {React.ReactNode} [props.action] - Optional action element (e.g., button)
 * @param {number} [props.count] - Optional item count to display
 * @returns {JSX.Element}
 *
 * @example
 * // Simple header
 * <SectionHeader title="Basic Information" />
 *
 * @example
 * // With action button
 * <SectionHeader title="Tiers" action={<Button onClick={onAdd}>Add</Button>} />
 *
 * @example
 * // With count
 * <SectionHeader title="Windows" count={3} />
 */
export const SectionHeader = ({ title, action, count }) => (
  <div className="section-header">
    <div className="section-header-left">
      <span className="section-header-title">{title}</span>
      {count !== undefined && (
        <span className="section-header-count">{count} items</span>
      )}
    </div>
    {action && <div className="section-header-action">{action}</div>}
  </div>
);

export default SectionHeader;
